import { currencyFormat } from 'common/helpers/numberHelper';

const MobileToggleSummary = (props) => {
  const { onToggleMobile, cart, settings } = props;
  const toggleMobileSummary = (e) => {
    e.preventDefault();
    onToggleMobile();
  };
  return (
    <div className="c7-checkout-template__toggle">
      <div>
        <a
          href="#"
          aria-label="Show order summary"
          onClick={toggleMobileSummary}
        >
          <span>Show order summary</span>
          <span>{currencyFormat(cart.total, settings)}</span>
        </a>
      </div>
    </div>
  );
};
export default MobileToggleSummary;
